import { ref } from 'vue';
import {
  pruneSelectedProfilesToVisibleUlids,
  buildCompareSelectionFilterFingerprint,
} from '@/helpers/jobProfileCompareSelection';

// When search or filters change, keep only selected profiles still on the page.
// First load and page changes do not clear selection.
export const useCompareSelectionPrune = () => {
  const hasLoadedOnce = ref(false);
  const lastFilterFingerprint = ref(null);

  const pruneSelectionIfFiltersChanged = (selectedProfiles, {
    searchTerm,
    selectedFilters,
    visibleUlids,
  }) => {
    const fingerprint = buildCompareSelectionFilterFingerprint({ searchTerm, selectedFilters });
    const shouldPrune = hasLoadedOnce.value
      && lastFilterFingerprint.value !== null
      && fingerprint !== lastFilterFingerprint.value;

    lastFilterFingerprint.value = fingerprint;
    hasLoadedOnce.value = true;

    if (!shouldPrune) {
      return selectedProfiles;
    }

    return pruneSelectedProfilesToVisibleUlids(selectedProfiles, visibleUlids);
  };

  return { pruneSelectionIfFiltersChanged };
};
